<template>
	<v-dialog v-model="dialog" max-width="1000px" persistent >
		<v-container grid-list-md px-0 py-0>
			<v-card>
				<v-card-title class="pb-0">
					<span class="headline">{{formTitle}}</span>
				</v-card-title>

				<v-card-text class="pt-0">
					<v-container grid-list-md px-0 py-0>
						<v-form v-model="valid" xs12>
							
							<v-layout row wrap>
								<v-flex xs12 sm2 md2>
									<v-text-field
										v-model="zipcode"
										:mask="'###.##-###'"
										label="Cep"										
									></v-text-field>
								</v-flex>	
								<v-flex xs12 sm4 md4>
									<v-text-field
										v-model="public_place"
										label="Endereço"		
										:rules="[v => !!v || 'Endereço é obrigatório!']"								
									></v-text-field>									
								</v-flex>	
								<v-flex xs12 sm2 md2>
								<v-text-field
										v-model="number"
										label="Número"		
										:rules="[v => !!v || 'Número é obrigatório!']"								
									></v-text-field>									
								</v-flex>	
								<v-flex xs12 sm4 md4>
								<v-text-field
										v-model="complement"
										label="Complemento"		
															
									></v-text-field>									
								</v-flex>							
							</v-layout>
								
							<v-layout row wrap>							
								<v-flex xs12 sm4 md4>
									<v-text-field v-model="neighborhood" label="Bairro"></v-text-field>
								</v-flex>
								<v-flex xs12 sm2 md2>
									<v-text-field v-model="city" label="Município"></v-text-field>
								</v-flex>								
								<v-flex xs12 sm2 md2>
									<v-text-field v-model="state" label="UF" maxlength="2" ></v-text-field>
								</v-flex>
								<v-flex xs12 sm4 md4>
									<v-text-field v-model="obs" label="OBS"></v-text-field>
								</v-flex>						
								
							</v-layout>
							<v-layout row wrap>
								
								<v-flex xs12 sm2 md2>
									<v-btn color="primary" @click.native="save" :disabled="!valid">Adicionar</v-btn>
								</v-flex>
							</v-layout>

									
						</v-form>
						<v-layout row wrap>
							<v-flex xs12 sm12 md12>
							<v-simple-table>
								 <template v-slot:default>
									 <thead>
										<tr>
											<th class="text-left">id</th>
											<th class="text-left">CEP</th>
											<th class="text-left">Endereço</th>
											<th class="text-left">OBS</th>
											<th class="text-left"></th>
										</tr>
									</thead>
									<tbody>
									<tr v-for="(item, index) in address" :key="item.id">
										<td>{{item.id}}</td>
										<td>{{item.zipe_code}}</td>
										<td>{{item.address}}</td>
										<td>{{item.obs}}</td>
										<td><v-icon small @click="deleteItem(item)" > delete </v-icon></td>
									</tr>
									</tbody>
								</template>
							</v-simple-table>
							</v-flex>
						</v-layout>


						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn color="gray" flat @click.native="close">Fechar</v-btn>
							
						</v-card-actions>
					</v-container>
				</v-card-text>
			</v-card>

		</v-container>
	</v-dialog>
</template>
<script>
	import moment from 'moment';
	import axios from 'axios';
	export default {
		props: ['active', 'finish', 'item'],
		data () {
			
			let newAddress = {
				zipcode: '',
				public_place: '',
				neighborhood: '',
				city: '',
				state: '',
				obs: '',
			}
			let edited = {}
			

			if(this.item.id){
				edited = this.item;
			}

			return {
				number:'',
				complement: '',
				zipcode: '',
				public_place: '',
				neighborhood: '',
				city: '',
				state: '',
				obs: '',
				dialog: this.active,
				editedItem: edited,
				valid: false,
				address: edited.address
			}
		},
		computed: {
			formTitle () {
				return this.editedItem.id ? 'Endereços: '+this.editedItem.name : 'Novo Cliente'
			}
		},
		watch: {
			dialog (val) {
				if (!val && this.finish) {
					this.finish();
				}
			},
			'zipcode': {
				handler (cep) {
					console.log('zipcode', cep);
					const validacep = /^[0-9]{8}$/;
    			if (validacep.test(cep)) {
						
						axios.get(`https://viacep.com.br/ws/${cep}/json`)
							.then(response => response.data).then(rs => {
								console.log('zipcode resp', rs);
								this.public_place = rs.logradouro;
								this.neighborhood = rs.bairro;
								this.city = rs.localidade;
								this.state = rs.uf;
								
							});
					}
				},
				deep: true 
			}
		},
		created () {
			this.initialize();
		},
		methods: {
			initialize () {
				
			},
			close () {
				this.dialog = false;
			},
			save () {
				
				this.newAddress = {
					client_id: this.editedItem.id,
					address:  `${this.public_place}, ${this.number} ${this.complement} - ${this.neighborhood} ${this.city} - ${this.state}`,
					zipe_code: this.zipcode,
					public_place: this.public_place,
					number: this.number,
					complement: this.complement,
					neighborhood: this.neighborhood,
					city: this.city,
					state: this.state,
					obs: this.obs,
					
				}				
				this.add();
			},
			add() {
				this.$http.post(`/addresses/store`, this.newAddress)
				.then(response => response.data)
				.then(json => {
					this.$notify({
						title: `Endereço adicionado com sucesso!`,
						type: 'success'
					});
					console.log(json);
					this.address.push(json);

					//this.close();
				}).catch(err => {
					this.$notify({
						duration: 15000,
						title: `Erro ao Adicionar`,
						text: err.response,
						type: 'error'
					});
				});
			},	
			deleteItem(item) {
			
			if (confirm(`Deseja realmente excluir?`)) {
				this.$http.delete(`/addresses/${item.id}`)
				.then(response => {
					this.$notify({
						title: `Excluido!`,
						type: 'error',
					});
					this.getList();
				});
			}
		},
		getList(){
			this.$http.get(`/addresses/list/${this.editedItem.id}`)
				.then(response => response.data).then(json => {
					
            		this.loading = false;
					this.address = json.items;
         
				});
		}
		

		}
	}
</script>
